import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

// True while msal starts up or navigates for a token: an error page here would only flash before
// the redirect takes over, and it would hide that recovery is already running.
export function useAuthInteractionPending(): boolean {
  const { inProgress } = useMsal();

  return inProgress !== InteractionStatus.None;
}
